import styled from "@emotion/styled"

import { scale } from "@utils/typography"

const Svg = styled.svg`
  width: 100%;
`

const StyledPath = styled.path`
  fill: none;
  stroke: ${props =>
    props.colour ? props.colour : props.theme.colours.primary};
  stroke-width: 8px;
`

const Text = styled.text`
  dominant-baseline: middle;
  ${scale(1 / 3)};
  font-weight: 700;
  fill: ${props => props.theme.colours.color};
  text-anchor: middle;
`

export { Svg, StyledPath, Text }
